<template>
  <div class="player-container" :style="buttonBackgroundStyle">
    <img :src="coverURL" alt="" class="album-cover" />
    {{ current_track }}
    <div class="palettes">
      <div
        v-for="(key, index) in Object.keys(colorPalette)"
        :key="index"
        :style="{ backgroundColor: colorPalette[key] }"
        class="palette"
      >
        <p>{{ key }}</p>
        <p>{{ colorPalette[key] }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'
import { getBlobFromUrl, convertBlobToBase64, getPaletteColorFromImageBase64 } from '../utils'
import * as Vibrant from 'node-vibrant'

const PlaybackStore = createNamespacedHelpers('PlaybackStore')

@Component({
  computed: {
    ...PlaybackStore.mapState(['current_track'])
  }
})
export default class Player extends Vue {
  artworkBase64 = ''
  colorPalette = {
    darkMuted: '',
    darkVibrant: '',
    lightMuted: '',
    lightVibrant: '',
    muted: '',
    vibrant: ''
  }
  get coverURL() {
    return this.current_track.album.images.length > 0 ? this.current_track.album.images[0].url : ''
  }

  get buttonBackgroundStyle() {
    return `background-image: linear-gradient(to bottom right,${this.colorPalette.darkVibrant},${this.colorPalette.vibrant})`
  }

  @Watch('coverURL')
  async onCoverURLChanged(newVal, oldVal) {
    if (newVal !== oldVal) {
      const blob = await getBlobFromUrl(this.coverURL)
      this.artworkBase64 = await convertBlobToBase64(blob)
      const palette = await getPaletteColorFromImageBase64(this.artworkBase64)
      this.colorPalette = {
        darkMuted: palette.DarkMuted.getHex(),
        darkVibrant: palette.DarkVibrant.getHex(),
        lightMuted: palette.LightMuted.getHex(),
        lightVibrant: palette.LightVibrant.getHex(),
        muted: palette.Muted.getHex(),
        vibrant: palette.Vibrant.getHex()
      }
    }
  }
}
</script>

<style lang="scss">
.player-container {
  border: 1px solid red;
  border-radius: 8px;
}
.album-cover {
  width: 250px;
  height: 250px;
  border-radius: 250px;
}

.container {
  margin: auto;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
}
.palettes {
  display: flex;
  margin: 2em 0;
  .palette {
    color: white;
    width: 100%;
  }
}
.artwork-cover {
  width: 200px;
  filter: blur(8px);
}
</style>
